import loadValidatorLocale from '@/dependencies/helpers/localize-validate'

export default (ctx) => {
  ctx.app.i18n.beforeLanguageSwitch = (oldLocale, newLocale) => {
    loadValidatorLocale(newLocale)
  }
}
